export enum SubstrateSearchScenario {
    Mail = 'owa.react',
    Calendar = 'owa.react.calendar',
    FilesHub = 'owa.react.filesHub',
    MailSubject = 'owa.react.mail.subject',
    MailEmailAttachmentPicker = 'owa.react.mail.emailPicker',
    MailAdvancedSearch = 'owa.react.mail.advancedSearch',
}

export default SubstrateSearchScenario;
